import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Camera } from '@ionic-native/camera';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { MyApp } from './app.component';

import { HomePage } from '../pages/home/home';
import { AnprPage } from '../pages/anpr/anpr';
import { QrscanPage } from '../pages/qrscan/qrscan';

import { FlashCardComponent } from '../components/flash-card/flash-card';
import { AppsComponent } from '../components/apps/apps';
import { CabeceraComponent } from '../components/cabecera/cabecera';
import { SharersComponent } from '../components/sharers/sharers';

import { GoogleCloudVisionServiceProvider } from '../providers/google-cloud-vision-service/google-cloud-vision-service';
import { ScansHistoryProvider } from '../providers/scans-history/scans-history';






@NgModule({
  declarations: [
    MyApp,
    HomePage,
    AnprPage,
    QrscanPage,
    CabeceraComponent,
    FlashCardComponent,
    AppsComponent,
    SharersComponent        
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    AnprPage,
    QrscanPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Camera,  
    BarcodeScanner, 
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    GoogleCloudVisionServiceProvider,
    ScansHistoryProvider,
    ScansHistoryProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts